import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { AcaoPrevCorretivasFilter } from "../../models/acao_prev_corretivas_filter copy";
import { AcaoPrevCorretivasLista } from "../../models/acao_prev_corretiva_lista";
import { IGetAllQualidadeAcaoPrevCorretivasUseCase } from "../../../presentation/useCases/read/get_all_qualidade_acao_prev_corretiva_use_case";


// GetAllQualidadeAcaoPrevCorretivasServicoUseCase


export class GetAllQualidadeAcaoPrevCorretivasServicoUseCase
  extends BasePaginatedUseCase<AcaoPrevCorretivasLista>
  implements IGetAllQualidadeAcaoPrevCorretivasUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemAcaoPrevCorretivas(
    filter: AcaoPrevCorretivasFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdAcaoQualidade === undefined) throw new Error('Id de ações de melhorias invalido!');

    const response = await this.repository
      .getAllListagemAcaoPrevCorretivas(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
